import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { EarnWithCian } from '../../components/EarnWithCian';
import { ActionContainer } from '../ActionContainer';
import { VideoPlaybackModalContainer } from '../VideoPlaybackModalContainer';

export const EarnWithCianContainer = () => {
  const device = useDeviceType();
  const { toggle: toggleModal, state: isModalOpen } = useToggleState();

  return (
    <>
      <EarnWithCian deviceType={device} action={<ActionContainer />} onVideoModalOpen={toggleModal} />
      <VideoPlaybackModalContainer deviceType={device} isOpen={isModalOpen} onClose={toggleModal} />
    </>
  );
};
